import React from 'react';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { MODULE_TYPE, PERMISSON_MODULES } from '../../Permission.config';
import Error403Component from '../Common/error-403';
import * as authActions from '../../redux/actions/userAuthAction'

const ShowForPermissionComponent = (props) => {
    let couldShow = false;
    let isPage = false;

    if (props.companyServices) {
        const companyServices = props.companyServices;
        let hasSelectedByCompany = true;
        switch (props.module) {
            case PERMISSON_MODULES.STD_FORM:
                hasSelectedByCompany = companyServices.hasSTDFormFeature;
                break;
            case PERMISSON_MODULES.AIR_FORM:
                hasSelectedByCompany = companyServices.hasAIRFormFeature;
                break;
            case PERMISSON_MODULES.ACMD_FORM:
                hasSelectedByCompany = companyServices.hasACMDFormFeature;
                break;
            case PERMISSON_MODULES.CCM_FORM:
                hasSelectedByCompany = companyServices.hasCCMFormFeature;
                break;
        }
        if (!hasSelectedByCompany)
            return <Error403Component />
    }

    if (Array.isArray(props.userPermissions)) {
        const userPermission = props.userPermissions.find(x => x.authModule == props.module)
        couldShow = userPermission && userPermission[props.permission] ? true : false;
        isPage = userPermission && userPermission.authModuleType == MODULE_TYPE.PAGE ? true : false;
    }
    if (couldShow) {
        return props.children
    }
    else if (isPage) {
        return <Error403Component />
    }
    else {
        return null
    }
};

ShowForPermissionComponent.propTypes = {
    permission: PropTypes.string.isRequired,
    module: PropTypes.string.isRequired,
    userPermissions: PropTypes.array.isRequired,
    companyServices: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
    userPermissions: state.userAuthReducer.userPermissions,
    companyServices: state.profileReducer.companyServices
});

export const ShowForPermission = connect(mapStateToProps)(ShowForPermissionComponent);